import React, { Component } from 'react';
import '../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js';
import { Link } from 'react-router-dom';

import logo from './logo.jpg';
// import RecipeRoutes from '../pages/recipes/reciperoutes';


class Navbar extends Component {

    

    render() {

        


        return <div className="navbar navbar-expand-lg navbar-dark bg-dark">
        <img src={logo} style={{ width: '30px', marginRight: '10px' }} />
        <Link className="navbar-brand" to="#">Steve's Bootstrap React Site</Link>
        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarsExample03" aria-controls="navbarsExample03" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
      
        <div className="collapse navbar-collapse" id="navbarsExample03">
          <ul className="navbar-nav ml-auto">
            <li className="nav-item active">
              <Link className="nav-link" to="/">Home <span className="sr-only">(current)</span></Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/site2">React Site (no router)</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/plain">Plain HTML Site</Link>
            </li>
            <li className="nav-item dropdown">
              <Link className="nav-link dropdown-toggle" to="#" id="dropdown03" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Other Stuff</Link>
              <div className="dropdown-menu" aria-labelledby="dropdown03">
                <Link className="dropdown-item" to="/recipes">Recipes</Link>
                {/* <Link className="dropdown-item" to="#">Another action</Link>
                <Link className="dropdown-item" to="#">Something else here</Link> */}
              </div>
            </li>
          </ul>
          {/* <form className="form-inline my-2 my-md-0">
            <input className="form-control" type="text" placeholder="Type text. Make disappear." />
          </form> */}
        </div>
      </div>
    }
};

export default Navbar;